import { render, staticRenderFns } from "./specificcrowddiscount.vue?vue&type=template&id=8583570e"
import script from "./specificcrowddiscount.vue?vue&type=script&lang=js"
export * from "./specificcrowddiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports